// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UDOJ7","featured_in":"styles_featured_in__Fv9Gc","heading":"styles_heading__Q_qin","image_wrapper":"styles_image_wrapper__Hd3BL"};